import { state } from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

const medicalOrders = {
  getters,
  mutations,
  state,
  actions
};

export default medicalOrders;
